<div class="container-fluid">
  <div class="row h-100">
    <div class="col-sm-auto p-0">
      <div class="nav-panel-wrapper">
        <app-navigation-panel></app-navigation-panel>
      </div>
    </div>

    <main class="main-container col-sm overflow-auto vh-100 m-0">
      <div class="content-wrapper">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>
<app-notification-bell />
